import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import dsBankApi from "service/TichHopBank/dsBankApi";
import { pushNotification } from "utils/notifications";
import { DanhSachBankConst } from "../../../../constants/danhSachTaiSanConst";
import danhsachNhanVienApi from "service/danhSachNhanVienApi";
import userApi from "../../../../service/userApi";
import Select from "react-select";
import DsCapPheDuyetApi from "../../../../service/QuyTrinhPheDuyet/CapPheDuyet/dsCapPheDuyetApi";
import NumberFormat from "react-number-format";

export const ThemMoiCapDuyet = (props) => {
  const dispatch = useDispatch();

  const initDataAddAndEditnew = {
    Id: 0,
    TenCapDuyet: "",
    Stt: "",
    SoTien: "",
    lstUser: [],
  };
  const [bDisable, setDisableButton] = useState(false);
  const [dataAddAndEditNew, setDataAddAndEdit] = useState(
    initDataAddAndEditnew
  );
  const [lstNhanVien, setLstNhanVien] = useState(false);
  const [selectedNhanVien, setSelectedNhanVien] = useState(null);

  const currentForm = useForm();
  const { handleSubmit } = currentForm;

  useEffect(() => {
    if (typeof props.data.Id != "undefined" && props.data.Id > 0) {
      setDataAddAndEdit(props.data);
      var lstUser = props.data.lstUser.map((item) => ({
        value: item.UserName,
        label: item.UserName,
      }));
      setSelectedNhanVien(lstUser);
    }
    userApi.getCurrentUser().then((res2) => {
      danhsachNhanVienApi
        .danhsach({
          email: "",
          phone: "",
          name: "",
          companyId: res2.data.CompanyID,
          pageIndex: 1,
          pageSize: 1000,
        })
        .then((response) => {
          if (response.status == "200") {
            const dataComboReturn = response.data.List.map((item) => ({
              value: item.Email,
              label: item.Email,
            }));
            setLstNhanVien(dataComboReturn);
          }
        });
    });
  }, [props.data.Id]);

  const handleChange = (selectedOption) => {
    setSelectedNhanVien(selectedOption);
  };
  const updateTextValue = (field) => (e) => {
    const data = { ...dataAddAndEditNew };
    data[field] = e.target.value;
    setDataAddAndEdit(data);
  };
  const [dataBankCombo, setDataBankCombo] = useState(DanhSachBankConst.Bank);

  const addOrEdit = () => {
    if (dataAddAndEditNew.TenCapDuyet === "") {
      pushNotification("Nhập tên cấp duyệt!", "error", "TOP_CENTER", 2000);
      return;
    }
    if (dataAddAndEditNew.SoTien === "") {
      pushNotification("Nhập số tiền!", "error", "TOP_CENTER", 2000);
      return;
    }

    var lstUser = selectedNhanVien.map((item) => ({
      UserName: item.label,
    }));
    dataAddAndEditNew.lstUser = lstUser;
    setDisableButton(true);
    DsCapPheDuyetApi.addOrUpdate(dataAddAndEditNew).then((response) => {
      setDisableButton(false);
      if (response.status === 200) {
        props.data.onSearch();
        setDataAddAndEdit(initDataAddAndEditnew);
        props.onHide();
        pushNotification("Thao tác thành công", "success", "TOP_CENTER", 2000);
      } else {
        pushNotification(response, "error", "TOP_CENTER", 2000);
      }
    });
  };

  return (
    <Modal
      {...props}
      size="modal-new-size modal-new-size"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="modal-new modal fade text-left popup-detail"
    >
      <Modal.Header>
        <h4 className="modal-title color7-bold" id="myModalLabel16">
          <span className="btn-icon-right">
            <img src="/app-assets/images/icon-logo-quan-ly-thu-chi.png" />
          </span>{" "}
          {dataAddAndEditNew.Id > 0 ? "Sửa" : "Thêm mới"} cấp phê duyệt
        </h4>

        <button
          type="button"
          className="close-popup-new"
          onClick={props.onHide}
        >
          <img src="/app-assets/images/icon-dong-popup-v2.png" />
        </button>
      </Modal.Header>
      <Modal.Body>
        <div className="form-body">
          <div className="card collapse-icon accordion-icon-rotate">
            <div
              id="headingCollapse196"
              className="card-header"
              href="#collapse196"
              aria-expanded="true"
              aria-controls="collapse196"
            >
              <a className="card-title lead info collapsed" href={() => false}>
                <h3>Thông tin</h3>
              </a>
            </div>
            <div
              id="collapse196"
              aria-labelledby="headingCollapse96"
              className="card-collapse collapse show"
              aria-expanded="true"
            >
              <div className="card-content">
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-4">
                      <div className="form-group">
                        <label className="label-control color7-bold">
                          Tên cấp duyệt <span className="canh-bao-red">*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control input-sm"
                          value={dataAddAndEditNew.TenCapDuyet}
                          onChange={updateTextValue("TenCapDuyet")}
                        />
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group">
                        <label className="label-control color7-bold">
                          Số tiền <span className="canh-bao-red">*</span>
                        </label>
                        <NumberFormat
                            onChange={updateTextValue("SoTien")}
                            className="form-control input-sm"
                            thousandSeparator
                            value={dataAddAndEditNew.SoTien}
                          />
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group">
                        <label className="label-control color7-bold">
                          Số thứ tự <span className="canh-bao-red">*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control input-sm"
                          value={dataAddAndEditNew.Stt}
                          onChange={updateTextValue("Stt")}
                        />
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group">
                        <label className="label-control color7-bold">
                          Tài khoản duyệt{" "}
                          <span className="canh-bao-red">*</span>
                        </label>
                        <Select
                          value={selectedNhanVien}
                          onChange={handleChange}
                          options={lstNhanVien}
                          isMulti={true}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer className="modal-footer button-popup-new-size">
        <button
          className="btn btn-new-main btn-checknew"
          onClick={addOrEdit}
          disabled={bDisable}
        >
          <span>
            <i className="mdi mdi-check"></i>
          </span>
          &nbsp; {dataAddAndEditNew.Id > 0 ? "Cập nhật" : "Thêm mới"} &nbsp;
        </button>
        &nbsp;
        <a
          className="btn btn-new-main btn-closenew"
          data-dismiss="modal"
          href={() => false}
          onClick={props.onHide}
        >
          <span>
            <i className="mdi mdi-close"></i>
          </span>{" "}
          &nbsp; Đóng &nbsp;
        </a>
      </Modal.Footer>
    </Modal>
  );
};
